<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods: {
    onResize () {
      this.$bus.$emit('resize')
    }
  },
  mounted () {
    this.onResize = this.onResize.bind(this)
    window.addEventListener('resize', this.onResize)
    function checkIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue